import React, { Fragment } from "react";
import { Helmet } from "react-helmet-async";
import Navbar from "../../components/Navbar/Navbar";
import PageTitle from "../../components/pagetitle/PageTitle";
import Gallery from "../../components/Gallery/Gallery";
import Footer from "../../components/footer/Footer";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Logo from "../../images/logo.webp";
import Phone from "../../images/telephone.svg";
import CursorMaus from "../../components/CursorMaus/CursorMaus";

const GalleryPage = () => {
  return (
    <Fragment>
      <Helmet>
        <title>Gallery | Cash Flow Summit 2026 Highlights</title>
        <meta
          name="description"
          content="Explore the gallery of Cash Flow Summit 2026, featuring event highlights, speakers, participants, and unforgettable moments."
        />
        <meta
          name="keywords"
          content="Cash Flow Summit gallery, Cash Flow Summit photos, event highlights"
        />
        <meta name="author" content="Jagmohan Singh" />
        <meta name="robots" content="index, follow" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Helmet>
      <Navbar Logo={Logo} hclass={"wpo-site-header s3"} telephone={Phone} />
      <PageTitle pageTitle={"Gallery"} pagesub={"Gallery"} />
      <Gallery />
      <Footer />
      <Scrollbar />
      <CursorMaus />
    </Fragment>
  );
};

export default GalleryPage;

